import { GenericSelect } from "@asez/component-library";
import { GenericInput } from "@asez/component-library";
import { SelectChangeEvent } from "@mui/material/Select";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useMemo, useState } from "react";
import { updateCustomQuestions } from "../../../../../store/steps/stepFourSlice";
import { STATIC_STRINGS } from "@asez/shared";
import { useDispatch } from "react-redux";
import { isEmpty } from "../../../../../utils";

const questionTypes: string[] = STATIC_STRINGS.questionTypes;

const CustomQuestionModal = ({ isModalOpen, setModalOpen }) => {
  const dispatch = useDispatch();
  const [customQuestion, setCustomQuestion] = useState("");
  const [customQuestionType, setCustomQuestionType] = useState("");

  const handleAddCustomQuestion = () => {
    if (customQuestion) {
      dispatch(
        updateCustomQuestions({
          question: customQuestion,
          questionType: customQuestionType,
          include: true,
        })
      );
      setCustomQuestion("");
      setCustomQuestionType(questionTypes[0]);
      setModalOpen("");
    }
  };

  const isValid = useMemo(() => {
    return !isEmpty(customQuestion);
  }, [customQuestion]);

  return (
    <Modal open={isModalOpen} onClose={() => setModalOpen(false)}>
      <Box className="bg-white p-6 rounded-2xl shadow-lg w-96 mx-auto mt-40 text-center">
        <h2 className="text-lg font-semibold mb-4">
          {STATIC_STRINGS.ADD_CUSTOM_QUESTION}
        </h2>
        <div className="flex flex-col justify-center items-center text-gray-700 mb-6">
          <GenericInput
            className="w-4/5 mx-auto"
            type="text"
            value={customQuestion}
            onChange={(e) => setCustomQuestion(e.target.value)}
            placeholder={STATIC_STRINGS.CUSTOM_QUESTION_PLACEHOLDER}
          />
          <div className="mt-2 w-full">
            <GenericSelect
              className="w-4/5 mx-auto"
              value={customQuestionType}
              placeholder={STATIC_STRINGS.TYPE_OF_QUESTION}
              onChange={(e: SelectChangeEvent) =>
                setCustomQuestionType(e.target.value)
              }
              options={questionTypes.map((type) => ({
                label: type,
                value: type,
              }))}
            />
          </div>
        </div>
        <div className="flex justify-center mt-4">
          <button
            onClick={() => setModalOpen(false)}
            className="btn btn-primary mx-2 px-3 py-1"
          >
            {STATIC_STRINGS.CANCEL}
          </button>
          <button
            onClick={handleAddCustomQuestion}
            className={`btn ${
              isValid ? `btn-outline cursor-pointer` : `btn-outline-disabled`
            } mx-2 px-3 py-1`}
            disabled={!isValid}
          >
            {STATIC_STRINGS.CONFIRM}
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default CustomQuestionModal;
